export const preloadedValues = {
  PrTrNcmsId: "",
  prTrCOFINSCSTCredito: "",
  prTrOperId: "",
  prTrCEST: "",
  prTrPISCSTCredito: "",
  prTrIndEscala: true,
  prTrIndEscalaCNPJFabricante: "",
};
